import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

class ImageTextShadow extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return content.map((item, index) => {
            const thumbnail = item?.thumbnail || item?.thumbnails?.image?.[0]?.url || '';

            return (
                <div
                    key={index}
                    className={`${styles.imageTextShadow} ${
                        content.length === 1 || content.length - 1 === index ? styles.imageTextShadowOnly : ''
                    }`}>
                    <a href={item.url} target="_blank">
                        <img
                            className={styles.imageTextShadowPic}
                            src={formatImageWebpAuto(thumbnail, 300, 170)}
                            alt=""
                        />
                        <div className={styles.imageTextShadowText}>{item.title}</div>
                    </a>
                </div>
            );
        });
    }
}

export default errorBoundary(ImageTextShadow);
